import { autoinject, bindable } from 'aurelia-framework';
import { ApiService } from '../../utils/api-service';
import { ImportService, IImportAM } from './import-api';

@autoinject
export class ImportEntryContainer {
	@bindable importId: string;
	@bindable fiscalYearId: string;
	@bindable serviceStructureId: string;

	importEntry: IImportAM;

	constructor(private importService: ImportService) {
	}

	attached() {
		this.getImport();
	}

	async getImport() {
		this.importEntry = null;
		this.importEntry = await this.importService.getImport(this.importId);
	}
}

export interface IChangeFilterParams {
	filter: string;
}
